import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5',
      key: '1kgmhc',
    },
  ],
  ['path', { d: 'M17.599 6.5a3 3 0 0 0 .399-1.375', key: 'tmeiqw' }],
  ['path', { d: 'M6.003 5.125A3 3 0 0 0 6.401 6.5', key: '105sqy' }],
  ['path', { d: 'M3.477 10.896a4 4 0 0 1 .585-.396', key: 'ql3yin' }],
  ['path', { d: 'M19.938 10.5a4 4 0 0 1 .585.396', key: '1qfode' }],
  ['path', { d: 'M6 18a4 4 0 0 1-1.967-.516', key: '2e4loj' }],
  ['path', { d: 'M19.967 17.484A4 4 0 0 1 18 18', key: '159ez6' }],
  ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
  ['path', { d: 'm15.7 10.4-.9.4', key: 'ayzo6p' }],
  ['path', { d: 'm9.2 13.2-.9.4', key: '1uzb3g' }],
  ['path', { d: 'm13.6 15.7-.4-.9', key: '11ifqf' }],
  ['path', { d: 'm10.8 9.2-.4-.9', key: '1pmk2v' }],
  ['path', { d: 'm15.7 13.5-.9-.4', key: '7ng02m' }],
  ['path', { d: 'm9.2 10.9-.9-.4', key: '1x66zd' }],
  ['path', { d: 'm10.5 15.7.4-.9', key: '3js94g' }],
  ['path', { d: 'm13.1 9.2.4-.9', key: '18n7mc' }],
];

/**
 * @component @name BrainCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNWEzIDMgMCAxIDAtNS45OTcuMTQyIDQgNCAwIDAgMC0yLjUyNiA1Ljc3IDQgNCAwIDAgMCAuNTU2IDYuNTg4IDQgNCAwIDAgMCA3LjYzNiAyLjEwNiAzLjIgMy4yIDAgMCAwIC4xNjQtLjU0NmMuMDI4LS4xMy4zMDYtLjEzLjMzNSAwYTMuMiAzLjIgMCAwIDAgLjE2My41NDYgNCA0IDAgMCAwIDcuNjM2LTIuMTA2IDQgNCAwIDAgMCAuNTU2LTYuNTg4IDQgNCAwIDAgMC0yLjUyNi01Ljc3QTMgMyAwIDEgMCAxMiA1IiAvPgogIDxwYXRoIGQ9Ik0xNy41OTkgNi41YTMgMyAwIDAgMCAuMzk5LTEuMzc1IiAvPgogIDxwYXRoIGQ9Ik02LjAwMyA1LjEyNUEzIDMgMCAwIDAgNi40MDEgNi41IiAvPgogIDxwYXRoIGQ9Ik0zLjQ3NyAxMC44OTZhNCA0IDAgMCAxIC41ODUtLjM5NiIgLz4KICA8cGF0aCBkPSJNMTkuOTM4IDEwLjVhNCA0IDAgMCAxIC41ODUuMzk2IiAvPgogIDxwYXRoIGQ9Ik02IDE4YTQgNCAwIDAgMS0xLjk2Ny0uNTE2IiAvPgogIDxwYXRoIGQ9Ik0xOS45NjcgMTcuNDg0QTQgNCAwIDAgMSAxOCAxOCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIzIiAvPgogIDxwYXRoIGQ9Im0xNS43IDEwLjQtLjkuNCIgLz4KICA8cGF0aCBkPSJtOS4yIDEzLjItLjkuNCIgLz4KICA8cGF0aCBkPSJtMTMuNiAxNS43LS40LS45IiAvPgogIDxwYXRoIGQ9Im0xMC44IDkuMi0uNC0uOSIgLz4KICA8cGF0aCBkPSJtMTUuNyAxMy41LS45LS40IiAvPgogIDxwYXRoIGQ9Im05LjIgMTAuOS0uOS0uNCIgLz4KICA8cGF0aCBkPSJtMTAuNSAxNS43LjQtLjkiIC8+CiAgPHBhdGggZD0ibTEzLjEgOS4yLjQtLjkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/brain-cog
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrainCog = createLucideIcon('brain-cog', __iconNode);

export default BrainCog;
